(function(){
function init(root){
if(root.dataset.sdInit)return;root.dataset.sdInit='1';
var D=JSON.parse(root.querySelector('.sd-data').textContent);
Object.keys(D).forEach(function(k){D[k].h=k;});
var promo=root.dataset.promo==='true',CODE=root.dataset.code,PCT=+root.dataset.pct||0,CART=root.dataset.cart,ROOT=root.dataset.root;
function q(s){return root.querySelector(s);}
function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');}
function money(c){return '$'+(c/100).toFixed(2);}
function off(c){return promo?Math.round(c*(100-PCT)/100):c;}
var SET={
m:[['goggle','force-revo-double-lens-goggle','Double lens, vented, anti-fog. Fits over glasses.',1,'Colour'],
['glove','mens-samurai-glove','Recycled REFLEX DURO fabric, adjustable wrist.',1,'Size'],
['sock','heater-ski-socks','Thick sock with 40% Australian merino.',1,'Size'],
['beanie','mens-woodie-beanie','Thinsulate insulation, fleece lined.',0,'Colour'],
['top','mens-merino-top','100% Australian merino, 230gm base layer.',0,'Size'],
['pant','mens-merino-pant','100% Australian merino, 230gm base layer.',0,'Size'],
['neck','x-neckband','Simple, reliable neck warmer.',0,'Colour']],
l:[['goggle','force-revo-double-lens-goggle','Double lens, vented, anti-fog. Fits over glasses.',1,'Colour'],
['glove','ladies-sapporo-glove','A crisp, clean classic with the features you need.',1,'Size'],
['sock','heater-ski-socks','Thick sock with 40% Australian merino.',1,'Size'],
['beanie','ladies-wilco-beanie','Thinsulate insulation, fleece lined.',0,'Colour'],
['top','ladies-merino-top','100% Australian merino, 230gm base layer.',0,'Size'],
['pant','ladies-merino-pant','100% Australian merino, 230gm base layer.',0,'Size'],
['neck','x-neckband','Simple, reliable neck warmer.',0,'Colour']]
};
var PRE={ess:{goggle:1,glove:1,sock:1,beanie:1,neck:1},warm:{goggle:1,glove:1,sock:3,beanie:1,top:1,pant:1,neck:1}};
var NOTE={ess:'Goggles, gloves, beanie, neck warmer and 1 pair of ski socks.',warm:'Everything in the Essentials Pack, plus 3 pairs of socks and a merino thermal top and pant.',own:'Everything is ticked to start. Untick anything you don\u2019t need and choose your sizes.'};
var on={},qty={},sel={},mode='own',range='m';
function preset(n){mode=n;if(PRE[n]){on={};qty={};for(var r in PRE[n]){on[r]=true;qty[r]=PRE[n][r];}}}
['goggle','glove','sock','beanie','top','pant','neck'].forEach(function(r){on[r]=true;qty[r]=1;});
function avail(p){return p.v.filter(function(v){return v[3];});}
function labels(p){
var parts=p.v.map(function(v){return v[0].split(' / ');}),keep=[];
if(parts.length>1){for(var k=0;k<parts[0].length;k++){var same=parts.every(function(a){return a[k]===parts[0][k];});if(!same)keep.push(k);}}
return parts.map(function(a){return keep.length?keep.map(function(k){return a[k];}).join(' / '):a.join(' / ');});
}
function chosen(p){var a=avail(p);if(a.length===1)return a[0];var id=sel[p.h];return a.filter(function(v){return String(v[1])===id;})[0]||null;}
function unit(p){var c=chosen(p);if(c)return c[4];var a=avail(p).length?avail(p):p.v;return Math.min.apply(null,a.map(function(v){return v[4];}));}
function render(){
var html='',sum=0,n=0,ids=[],missing=[];
SET[range].forEach(function(it){
var p=D[it[1]];if(!p)return;
var r=it[0],ok=avail(p).length>0,checked=ok&&!!on[r],qn=qty[r]||1,c=chosen(p),u=unit(p),line=u*qn;
if(checked){sum+=line;n+=qn;if(c)ids.push(c[1]+':'+qn);else missing.push(p.t);}
html+='<div class="sd-item'+(checked?' on':'')+'"><div class="sd-row"><input type="checkbox" id="sd-c-'+r+'" data-k="'+r+'"'+(checked?' checked':'')+(ok?'':' disabled')+' aria-label="Include '+esc(p.t)+'">'+
'<div class="sd-ic">'+(p.i?'<img src="'+esc(p.i)+'" alt="'+esc(p.t)+'" loading="lazy">':'')+'</div>'+
'<label for="sd-c-'+r+'"><b>'+esc(p.t)+(it[3]?'<span class="sd-tag">Best seller</span>':'')+'</b><small>'+(ok?esc(it[2]):'Currently sold out')+' · <a href="'+esc(p.u)+'">Details and size guide</a></small></label>'+
'<div class="sd-pr">'+(promo?'<s>'+money(u)+'</s><em>'+money(off(u))+'</em>':money(u))+'</div></div>';
if(checked){
var a=avail(p),lab=labels(p),opts='<option value="">Choose '+it[4].toLowerCase()+'</option>';
html+='<div class="sd-pick">';
if(a.length>1){
p.v.forEach(function(v,i){
var low=(v[3]&&v[2]>0&&v[2]<=5)?' (only '+v[2]+' left)':'';
opts+='<option value="'+v[1]+'"'+(v[3]?'':' disabled')+(sel[p.h]===String(v[1])?' selected':'')+'>'+esc(lab[i])+(v[3]?low:' (sold out)')+'</option>';
});
html+='<span>'+it[4]+'</span><select data-s="'+p.h+'" class="'+(c?'':'need')+'" aria-label="'+it[4]+' for '+esc(p.t)+'">'+opts+'</select>';
}else{
html+='<span>'+esc(labels(p)[p.v.indexOf(a[0])])+'</span>';
}
var qo='';for(var i=1;i<=6;i++){qo+='<option value="'+i+'"'+(i===qn?' selected':'')+'>'+i+'</option>';}
html+='<span>Qty</span><select data-q="'+r+'" style="min-width:70px" aria-label="Quantity for '+esc(p.t)+'">'+qo+'</select></div>';
}
html+='</div>';
});
q('.sd-items').innerHTML=html;
var sale=off(sum),ready=n>0&&missing.length===0,cart=q('.sd-cart');
q('.sd-sum .c').textContent=n+(n===1?' item':' items')+' selected';
q('.sd-sum .was').textContent=(promo&&n)?money(sum):'';
q('.sd-sum .t').innerHTML=money(sale)+' <small>AUD</small>';
q('.sd-sum .save').textContent=(promo&&n)?'You save '+money(sum-sale)+' with code '+CODE:'';
var path=CART+'/'+ids.join(',');
cart.href=ready?(promo?ROOT+'discount/'+encodeURIComponent(CODE)+'?redirect='+encodeURIComponent(path):path):'#';
cart.setAttribute('aria-disabled',ready?'false':'true');
q('.sd-sum .need-msg').textContent=n===0?'Tick at least one item.':(missing.length?'Choose an option for: '+missing.join(', ')+'.':'');
q('.sd-bm').setAttribute('aria-pressed',range==='m');
q('.sd-bl').setAttribute('aria-pressed',range==='l');
root.querySelectorAll('.sd-pre button').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-p')===mode);});
q('.sd-pn').textContent=NOTE[mode];
}
root.addEventListener('change',function(e){
var t=e.target,k=t.getAttribute('data-k'),s=t.getAttribute('data-s'),r=t.getAttribute('data-q'),f=null;
if(k){on[k]=t.checked;if(t.checked&&!qty[k])qty[k]=1;mode='own';f='sd-c-'+k;}
if(s){sel[s]=t.value;f='[data-s="'+s+'"]';}
if(r){qty[r]=+t.value;mode='own';f='[data-q="'+r+'"]';}
if(f){render();var el=f.charAt(0)==='['?q(f):document.getElementById(f);if(el)el.focus();}
});
root.addEventListener('click',function(e){
var b=e.target.closest('.sd-pre button');
if(b){var pn=b.getAttribute('data-p');if(pn==='own'){mode='own';}else{preset(pn);}render();return;}
if(e.target.closest('.sd-cart')&&e.target.closest('.sd-cart').getAttribute('aria-disabled')==='true'){e.preventDefault();}
});
q('.sd-bm').addEventListener('click',function(){range='m';render();});
q('.sd-bl').addEventListener('click',function(){range='l';render();});
var cc=q('.sd-code');
if(cc){cc.addEventListener('click',function(){
var h=q('.sd-hint');
var ok=function(){h.textContent='Copied. Use '+CODE+' at checkout.';};
var no=function(){h.textContent='Enter '+CODE+' at checkout.';};
try{if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(CODE).then(ok,no);}else{no();}}catch(x){no();}
});}
render();
}
function all(c){(c||document).querySelectorAll('.sd[data-cart]').forEach(init);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){all();});}else{all();}
document.addEventListener('shopify:section:load',function(e){all(e.target);});
})();